import React, { FC } from "react";
import { faFileSignature } from "@fortawesome/pro-regular-svg-icons/faFileSignature";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const FileSignature: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faFileSignature} {...props} />
);
